import {
  Button,
  Form,
  Input,
  Card,
  notification,
  Checkbox,
  Space,
  Typography,
  Select
} from 'antd'
import { LockOutlined, UserOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { useAuthStore } from 'src/store/auth'
import { useDictionariesStore } from 'src/store/dictionaries'
import { useEffect, useState } from 'react'

import './SignUpForm.css'

const { Text } = Typography
const { TextArea } = Input

const SignUpForm = () => {
  const [form] = Form.useForm()
  const emailValue = Form.useWatch('email', form)
  const passwordValue = Form.useWatch('password', form)
  const usernameValue = Form.useWatch('username', form)
  const displayNameValue = Form.useWatch('display_name', form)
  const confirmPasswordValue = Form.useWatch('password_confirmation', form)

  const [api, contextHolder] = notification.useNotification()
  const [error, setError] = useState(null)
  const [agree, setAgree] = useState(false)

  const { signUpUser } = useAuthStore((store) => store)
  const { loadTimezones, timezones } = useDictionariesStore((store) => store)

  const onFinish = async (values) => {
    const res = await signUpUser({ ...values, role: 'provider' })
    if (!res?.success) {
      if (res?.errors) {
        const ErrorsBody = () => (
          <Space direction={'vertical'}>
            {res?.errors &&
              res?.errors.map((error) => <Text type='danger'>{error}</Text>)}
          </Space>
        )

        api.error({
          message: `Sign Up Error`,
          description: <ErrorsBody />,
          placement: 'topRight'
        })
      } else {
        api.error({
          message: `Sign Up Error`,
          description: res?.error || 'Error',
          placement: 'topRight'
        })
      }

      setError(res)
    }
  }

  const onFinishFailed = (errorInfo) => {}

  useEffect(() => {
    if (!timezones) loadTimezones()
  }, [])

  useEffect(() => {
    setError(null)
  }, [
    emailValue,
    passwordValue,
    displayNameValue,
    usernameValue,
    confirmPasswordValue
  ])

  return (
    <Card
      title='Sign Up'
      style={{
        maxWidth: 400,
        width: '100%'
      }}
      headStyle={{
        textAlign: 'center',
        fontSize: '30px',
        padding: '20px'
      }}
    >
      {contextHolder}
      <Form
        form={form}
        className='clear-form'
        layout='vertical'
        name='basic'
        style={{
          maxWidth: 400,
          width: '100%'
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete='off'
      >
        {error && (
          <Space direction={'vertical'} style={{ marginBottom: 15 }}>
            {error?.errors ? (
              error?.errors.map((error) => <Text type='danger'>{error}</Text>)
            ) : (
              <Text type='danger'>{error?.error}</Text>
            )}
          </Space>
        )}
        <Form.Item
          name='email'
          label='Email'
          rules={[{ required: true, message: 'Please input your email!' }]}
        >
          <Input
            type='email'
            prefix={<UserOutlined className='site-form-item-icon' />}
            placeholder='email'
          />
        </Form.Item>
        <Form.Item
          name='username'
          label='Username'
          rules={[{ required: true, message: 'Please input your username!' }]}
        >
          <Input
            prefix={<UserOutlined className='site-form-item-icon' />}
            placeholder='username'
          />
        </Form.Item>
        <Form.Item
          name='display_name'
          label='Display name'
          rules={[
            { required: true, message: 'Please input your display name!' }
          ]}
        >
          <Input
            prefix={<UserOutlined className='site-form-item-icon' />}
            placeholder='Display name'
          />
        </Form.Item>
        <Form.Item label='Description' name='description'>
          <TextArea rows={2} />
        </Form.Item>
        <Form.Item
          name='password'
          label='Password'
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <Input.Password
            prefix={<LockOutlined className='site-form-item-icon' />}
            type='password'
            placeholder='Password'
          />
        </Form.Item>
        <Form.Item
          name='password_confirmation'
          label='Confirm Password'
          rules={[
            { required: true, message: 'Please input your confirm password!' }
          ]}
        >
          <Input.Password
            prefix={<LockOutlined className='site-form-item-icon' />}
            type='password'
            placeholder='Confirm password'
          />
        </Form.Item>

        <Form.Item
          name='timezone_id'
          label='Timezone'
          rules={[{ required: true, message: 'Please input your timezone!' }]}
        >
          <Select
            defaultValue=''
            fieldNames={{ label: 'name', value: 'id' }}
            options={timezones}
          />
        </Form.Item>

        <Space style={{ marginBottom: 20, marginTop: 10 }}>
          <Checkbox
            checked={agree}
            onChange={(e) => setAgree(e.target.checked)}
          >
            I agree to the <Link to='/terms-of-use'>Terms of service</Link>
          </Checkbox>
        </Space>

        <Form.Item>
          <Button
            type='primary'
            block
            htmlType='submit'
            className='login-form-button'
            disabled={!agree}
          >
            Sign Up
          </Button>
          <Link to={'/sign-in'}>I already have an account</Link>
        </Form.Item>
      </Form>
    </Card>
  )
}
export default SignUpForm
